module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/cardboard-vr-87e51bc29acdf9b7afef90dccaad4403.svg";